export class PipelineHistoryKindFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<PipelineHistoryKind>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<PipelineHistoryKind>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PipelineHistoryKindFilters.attributeTypeMap;
    }
    constructor() {
    }
}
